export const EMPLOYEE_CONSTANTS = {
  NEW_EMPLOYEE_REQUEST: 'NEW_EMPLOYEE_REQUEST',
  NEW_EMPLOYEE_SUCCESS: 'NEW_EMPLOYEE_SUCCESS',
  NEW_EMPLOYEE_FAIL: 'NEW_EMPLOYEE_FAIL',
  RESET_NEW_EMPLOYEE: 'RESET_NEW_EMPLOYEE',

  GET_EMPLOYEE_REQUEST: 'GET_EMPLOYEE_REQUEST',
  GET_EMPLOYEE_SUCCESS: 'GET_EMPLOYEE_SUCCESS',
  GET_EMPLOYEE_FAIL: 'GET_EMPLOYEE_FAIL',

  UPDATE_EMPLOYEE_REQUEST: 'UPDATE_EMPLOYEE_REQUEST',
  UPDATE_EMPLOYEE_SUCCESS: 'UPDATE_EMPLOYEE_SUCCESS',
  UPDATE_EMPLOYEE_FAIL: 'UPDATE_EMPLOYEE_FAIL',
  UPDATE_EMPLOYEE_RESET: 'DELETE_EMPLOYEE_RESET',

  DELETE_EMPLOYEE_REQUEST: 'DELETE_EMPLOYEE_REQUEST',
  DELETE_EMPLOYEE_SUCCESS: 'DELETE_EMPLOYEE_SUCCESS',
  DELETE_EMPLOYEE_FAIL: 'DELETE_EMPLOYEE_FAIL',
  DELETE_EMPLOYEE_RESET: 'DELETE_EMPLOYEE_RESET',

  CLEAR_ERRORS: 'CLEAR_ERRORS',
}
